import config from "./config.json";
import modules from "../../../modules/componentLoader";
import "Styles/section/section.less";
import "Styles/split-box/split-box.less";
import "Styles/tabs/tabs.less";
import "Styles/phones/phones.less";

const getConfig = async () => {
    //preloading UI feature before returning Widget UI configuration
    await modules.load("article");
    return config;
};
export { getConfig };
